import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);

window.enableAnalytics = async () => {
  const [{ default: reportWebVitals }, { sendToVercelAnalytics }] = await Promise.all([
    import("./reportWebVitals"),
    import("./vitals"),
  ]);
  reportWebVitals(sendToVercelAnalytics);
  const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (gaId && !window.gaLoaded) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag("js", new Date());
    gtag("config", gaId, { anonymize_ip: true });

    window.gaLoaded = true;
  }
};

if (localStorage.getItem("cookieAccepted") === "true") {
  window.enableAnalytics();
}
